import React from 'react';
import { clipboardOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';

interface SectionEmptyStateProps {
  text?: string;
  icon?: any;
  onClick?: () => void;
}

const SectionEmptyState: React.FC<SectionEmptyStateProps> = (props) => {
  const icon = props.icon || clipboardOutline;
  const text = props.text || 'Você não lançou nenhuma informação nesta sessão.';
  const onClick = props.onClick;
  const cursorPointer = onClick ? 'cursor-pointer' : '';

  return (
    <div
      className={`app-page-section-empty-state px-12 py-8 md:py-16 ${cursorPointer}`}
      onClick={() => (onClick ? onClick() : null)}>
      <div className="flex justify-center">
        <IonIcon
          icon={icon}
          className="text-4xl md:text-6xl opacity-50"
        />
      </div>
      <div className="text-pal-opaco60 mt-2 text-center">{text}</div>
    </div>
  );
};

export default SectionEmptyState;
